import { FC } from 'react'

import { useScrollRestoration } from './useScrollRestoration'

/**
 * Used to restore scroll positions between app and pages router, as the
 * experimental flag `scrollRestoration` in `next.config.js` does not support
 * restoring scroll between the routing strategies.
 *
 * FIXME: once PLP is on app router, this can be removed and we can leverage
 * the experimental flag fully.
 */
export const ScrollRestorer: FC = () => {
  useScrollRestoration()
  return null
}
